import { Observable } from 'rxjs/Observable';

import { UPDATE_ROUTE, routerLocationChanged } from '../redux/route';

// This epic recieves updated route information and then will trigger ROUTER_LOCATION_CHANGED
// after the route store information has been updated and all the correct information is
// available for other epics to use during ROUTER_LOCATION_CHANGED.
export default function updateRouteEpic(action$: ActionObs, store: Store): Obs {
  return action$.ofType(UPDATE_ROUTE).switchMap(() => {
    const { currentRoute } = store.getState().route;
    return Observable.of(routerLocationChanged(currentRoute));
  });
}
